import api, { transformRequest, transformResponse } from "services/api";

export const debtorAssetCustomFieldsApi = api
  .enhanceEndpoints({
    addTagTypes: ["DebtorAssetCustomField"],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      fetchAllDebtorAssetCustomFields: build.query({
        query: () => `/api/v1/core/debtor-asset-custom-fields/`,
        transformResponse: (response) => transformResponse(response),
        providesTags: (results) =>
          results
            ? [
                ...results.map(({ id }) => ({ type: "DebtorAssetCustomField", id })),
                { type: "DebtorAssetCustomField", id: "LIST" },
              ]
            : [{ type: "DebtorAssetCustomField", id: "LIST" }],
      }),
      addDebtorAssetCustomField: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtor-asset-custom-fields/create/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        invalidatesTags: [{ type: "DebtorAssetCustomField", id: "LIST" }],
      }),
      updateDebtorAssetCustomField: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtor-asset-custom-fields/${payload.id}/update/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        invalidatesTags: [{ type: "DebtorAssetCustomField", id: "LIST" }],
      }),
      deleteDebtorAssetCustomField: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtor-asset-custom-fields/${payload.id}/delete/`,
          method: "POST",
        }),
        invalidatesTags: [{ type: "DebtorAssetCustomField", id: "LIST" }],
      }),
      fetchDebtorAssetCustomField: build.query({
        query: (payload) => `/api/v1/core/debtor-asset-custom-fields/${payload.id}/`,
        transformResponse: (response) => transformResponse(response),
      }),
    }),
    overrideExisting: false,
  });

export const {
  useFetchAllDebtorAssetCustomFieldsQuery,
  useAddDebtorAssetCustomFieldMutation,
  useUpdateDebtorAssetCustomFieldMutation,
  useDeleteDebtorAssetCustomFieldMutation,
  useLazyFetchDebtorAssetCustomFieldQuery,
} = debtorAssetCustomFieldsApi;
